<div class="modal-header">
    <h4 class="modal-title">
        {{ title }}
        @if (target.status === 'Submitted') {
            <span class="badge bg-success ms-2">Submitted</span>
        } @else {
            <span class="badge bg-secondary ms-2">Draft</span>
        }
    </h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        <h6 class="text-muted text-uppercase small mb-2">General Information</h6>
        <div class="row mb-3">
            <div class="col-md-4 form-group">
                <label for="incidentOn">Date &amp; Time of Incident</label>
                <wj-input-date-time id="incidentOn" name="incidentOn" [(ngModel)]="target.incidentOn"></wj-input-date-time>
            </div>
            <div class="col-md-4 form-group">
                <label for="reportingPartyUserId">Reporting Party</label>
                <wj-combo-box
                    id="reportingPartyUserId"
                    name="reportingPartyUserId"
                    [(ngModel)]="target.reportingPartyUserId"
                    [itemsSource]="userList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                ></wj-combo-box>
            </div>
            <div class="col-md-4 form-group">
                <label for="supervisorUserId">Supervisor</label>
                <wj-combo-box
                    id="supervisorUserId"
                    name="supervisorUserId"
                    [(ngModel)]="target.supervisorUserId"
                    [itemsSource]="userList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-8 form-group">
                <label for="location">Location</label>
                <app-voice-text-field
                    [(ngModel)]="target.location"
                    name="location"
                    inputId="location"
                    [rows]="2"
                    [showLocationButton]="true"
                ></app-voice-text-field>
            </div>
            <div class="col-md-4 form-group">
                <label for="jobNumber">Job</label>
                <wj-combo-box
                    id="jobNumber"
                    name="jobNumber"
                    [(ngModel)]="target.jobNumber"
                    [itemsSource]="jobList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="equipmentOrVehicleNumber">Equipment # or Vehicle # Involved</label>
                <input type="text" class="form-control" id="equipmentOrVehicleNumber" name="equipmentOrVehicleNumber" [(ngModel)]="target.equipmentOrVehicleNumber" />
            </div>
            <div class="col-md-6 form-group">
                <label for="incidentType">Incident Type</label>
                <wj-combo-box
                    id="incidentType"
                    name="incidentType"
                    [(ngModel)]="target.incidentType"
                    [itemsSource]="incidentTypeList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    [isEditable]="false"
                ></wj-combo-box>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="text-muted text-uppercase small mb-0">Employees Involved</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addEmployee()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Employee
            </button>
        </div>
        @if (target.employees.length === 0) {
            <p class="text-muted small">No employees added.</p>
        }
        @for (employee of target.employees; track employee.id; let i = $index) {
            <div class="row mb-2 align-items-end">
                <div class="col form-group mb-0">
                    <label [for]="'employee_' + i">Employee</label>
                    <wj-combo-box
                        [id]="'employee_' + i"
                        [name]="'employee_' + i"
                        [(ngModel)]="employee.userId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-auto pb-1">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeEmployee(i)">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Incident Details</h6>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="whatHappened">Describe What Happened</label>
                <app-voice-text-field [(ngModel)]="target.whatHappened" name="whatHappened" inputId="whatHappened" [rows]="3"></app-voice-text-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="causeOfIncident">Cause of the Incident</label>
                <app-voice-text-field [(ngModel)]="target.causeOfIncident" name="causeOfIncident" inputId="causeOfIncident" [rows]="2"></app-voice-text-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="thirdPartyInfo">Third Party Involved - Information</label>
                <app-voice-text-field [(ngModel)]="target.thirdPartyInfo" name="thirdPartyInfo" inputId="thirdPartyInfo" [rows]="2"></app-voice-text-field>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2">Emergency Response</h6>
        <div class="row mb-3">
            <div class="col-md-3 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="policeOnScene" name="policeOnScene" [(ngModel)]="target.policeOnScene" />
                    <label class="form-check-label" for="policeOnScene">Police on scene</label>
                </div>
            </div>
            <div class="col-md-3 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="fireOnScene" name="fireOnScene" [(ngModel)]="target.fireOnScene" />
                    <label class="form-check-label" for="fireOnScene">Fire on scene</label>
                </div>
            </div>
            <div class="col-md-3 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="emsOnScene" name="emsOnScene" [(ngModel)]="target.emsOnScene" />
                    <label class="form-check-label" for="emsOnScene">EMS on scene</label>
                </div>
            </div>
            <div class="col-md-3 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="witnessesPresent" name="witnessesPresent" [(ngModel)]="target.witnessesPresent" />
                    <label class="form-check-label" for="witnessesPresent">Witnesses present</label>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="caseNumber">Case Number</label>
                <input type="text" class="form-control" id="caseNumber" name="caseNumber" [(ngModel)]="target.caseNumber" />
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="text-muted text-uppercase small mb-0">Witnesses</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addWitness()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Witness
            </button>
        </div>
        @if (target.witnesses.length === 0) {
            <p class="text-muted small">No witnesses added.</p>
        }
        @for (witness of target.witnesses; track witness.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Witness {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeWitness(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="form-group">
                        <label [for]="'witnessContact_' + i">Contact Information</label>
                        <input type="text" class="form-control" [id]="'witnessContact_' + i" [name]="'witnessContact_' + i" [(ngModel)]="witness.contactInformation" />
                    </div>
                    <div class="form-group mb-2">
                        <label [for]="'witnessStatement_' + i">Witness Statement</label>
                        <app-voice-text-field
                            [(ngModel)]="witness.statement"
                            [name]="'witnessStatement_' + i"
                            [inputId]="'witnessStatement_' + i"
                            [rows]="2"
                        ></app-voice-text-field>
                    </div>
                    <div class="form-group mb-0">
                        <label [for]="'witnessSignature_' + i">Witness Signature</label>
                        <input type="text" class="form-control" [id]="'witnessSignature_' + i" [name]="'witnessSignature_' + i" [(ngModel)]="witness.signature" />
                    </div>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Injury / Accident</h6>
        <div class="row mb-3">
            <div class="col-md-4 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="resultCausedInjury" name="resultCausedInjury" [(ngModel)]="target.resultCausedInjury" />
                    <label class="form-check-label" for="resultCausedInjury">Result caused injury or accident</label>
                </div>
            </div>
        </div>
        @if (target.resultCausedInjury) {
            <div class="row mb-3">
                <div class="col-12 form-group">
                    <label for="injuryDescription">What was the Injury or Accident?</label>
                    <app-voice-text-field [(ngModel)]="target.injuryDescription" name="injuryDescription" inputId="injuryDescription" [rows]="2"></app-voice-text-field>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2">Investigation Outcome</h6>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="rootCause">Root Cause of the Incident</label>
                <app-voice-text-field [(ngModel)]="target.rootCause" name="rootCause" inputId="rootCause" [rows]="2"></app-voice-text-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="correctiveAction">Corrective Action</label>
                <app-voice-text-field [(ngModel)]="target.correctiveAction" name="correctiveAction" inputId="correctiveAction" [rows]="2"></app-voice-text-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="primaryCause">Primary Cause of the Incident</label>
                <app-voice-text-field [(ngModel)]="target.primaryCause" name="primaryCause" inputId="primaryCause" [rows]="2"></app-voice-text-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="disciplinaryActionsGiven" name="disciplinaryActionsGiven" [(ngModel)]="target.disciplinaryActionsGiven" />
                    <label class="form-check-label" for="disciplinaryActionsGiven">Disciplinary actions given</label>
                </div>
            </div>
            <div class="col-md-6 form-group">
                <label for="safetyDeptSignature">Signature of Safety Department</label>
                <input type="text" class="form-control" id="safetyDeptSignature" name="safetyDeptSignature" [(ngModel)]="target.safetyDeptSignature" />
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2">Photos of Incident</h6>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row mb-3">
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingImageSrc(url)"
                            (click)="openExistingImage(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row mb-3">
                <label>Photos To Upload</label>
                @for (file of images; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="file.url" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row mb-3">
                <div class="col-12">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width.%': progress }"></div>
                    </div>
                </div>
            </div>
        }
        <div class="row mb-3">
            <div class="col-12">
                <input type="file" accept="image/*" multiple hidden #fileInput (change)="onFileChanged($event)" />
                <button type="button" class="btn btn-sm btn-secondary" (click)="fileInput.click()">Add Photos</button>
            </div>
        </div>
    </div>
    <div class="modal-footer ii-modal-footer">
        <button id="btnSaveDraft" type="button" class="btn btn-outline-secondary" (click)="saveDraft()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span><fa-icon [icon]="faSave"></fa-icon>&nbsp;@if (target.status === 'Submitted') { Save } @else { Save Draft }</span>
            }
        </button>
        <button id="btnSubmit" type="submit" class="btn btn-primary" (click)="submit()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Submitting</span>
            } @else {
                <span><fa-icon [icon]="faPaperPlane"></fa-icon>&nbsp;Submit</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
